import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { hasValue } from '@progress-fe/core';
import { Box, Button, Center, Flex, Grid, GridItem, IconButton } from '@chakra-ui/react';
import { Svg } from '../../base';
import { JsFieldInspector, JsFieldName } from '../../jsFormBase';
import { Checkbox, InputNumber } from '../../inputs';
import { useJsFieldFormData } from '../../../hooks';
import { JsFormConfigContext } from '../../../contexts';
const MAX_RAWS_AMOUNT = 5;
/**
 * Component renders "/schemas/jsf-oil-sample-curves" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is an instance of TOilSampleCurvesFormData.
 */
const OilSampleCurvesJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const formData = props.formData;
    const { fieldConfig, fieldValues, onChangeFieldValues } = useJsFieldFormData({
        config: formData.fieldConfig,
        values: formData.fieldValues,
        onChange: props.onChange,
        watchPropsChanges: true
    });
    const isCheckboxAvailable = fieldConfig?.isCheckbox;
    const isChecked = fieldValues?.checkboxValue;
    const rawsAmount = fieldValues?.value.length ?? 0;
    const isDeleteRawDisabled = rawsAmount <= MAX_RAWS_AMOUNT || (isChecked && fieldConfig?.isCheckbox);
    const handleChangeCheckboxValue = (value) => {
        if (!fieldValues) {
            return;
        }
        onChangeFieldValues({
            ...fieldValues,
            checkboxValue: value
        });
    };
    const handleChangeValue = (value) => {
        if (!fieldValues) {
            return;
        }
        onChangeFieldValues({
            ...fieldValues,
            value
        });
    };
    const handleChangeValueA = (index, valueA) => {
        const valueCopy = [...(fieldValues?.value ?? [])];
        valueCopy[index].valueA = valueA;
        handleChangeValue(valueCopy);
    };
    const handleChangeValueB = (index, valueB) => {
        const valueCopy = [...(fieldValues?.value ?? [])];
        valueCopy[index].valueB = valueB;
        handleChangeValue(valueCopy);
    };
    const handleAdd = () => {
        const valueCopy = [...(fieldValues?.value ?? [])];
        valueCopy.push({ valueA: null, valueB: null });
        handleChangeValue(valueCopy);
    };
    const handleDelete = (index) => {
        const valueCopy = [...(fieldValues?.value ?? [])];
        valueCopy.splice(index, 1);
        handleChangeValue(valueCopy);
    };
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsx(Box, { "data-testid": "OilSampleCurvesJsFieldFC-test", "data-name": props.name, children: _jsxs(Flex, { p: "4px 0", flexDirection: "column", gap: "8px", children: [isCheckboxAvailable && (_jsxs(Grid, { gap: "4px", gridTemplateColumns: `minmax(0, 180px) 1fr`, alignItems: 'center', children: [_jsx(JsFieldName, { name: "\u0417\u0430\u0432\u0438\u0441\u0438\u043C\u0430\u044F \u043A\u0440\u0438\u0432\u0430\u044F" }), _jsx(Checkbox, { checked: isChecked, isDisabled: props.schema.readOnly, onChange: handleChangeCheckboxValue })] })), _jsxs(Box, { p: "4px 4px 1px 4px", borderRadius: "4px", border: "1px solid", borderColor: "border", children: [_jsxs(Grid, { gap: "4px", p: "2px 0 6px 0", alignItems: "center", borderBottom: "1px solid", borderColor: "border", templateColumns: "172px 1fr", children: [_jsx(GridItem, { p: "0 0 0 2px", children: fieldConfig?.fieldA.title }), _jsx(GridItem, { p: "0 0 0 2px", children: fieldConfig?.fieldB.title })] }), _jsxs(Box, { p: "2px 0", children: [fieldValues?.value.map((item, index) => (_jsxs(Grid, { gap: "4px", p: "2px 0", templateColumns: "172px 1fr 24px", children: [_jsx(InputNumber, { isFloat: true, min: fieldConfig?.fieldA.min ?? 0, max: fieldConfig?.fieldA.max, size: "xs", variant: "outline", sx: { width: '100%' }, isOnChangeOnlyOnBlur: true, value: item.valueA ?? undefined, isInvalid: !hasValue(item.valueA), disabled: props.schema.readOnly || (isChecked && fieldConfig?.isCheckbox), rightElement: fieldConfig?.fieldA.unit, onChange: (value) => handleChangeValueA(index, value) }), _jsx(InputNumber, { isFloat: true, min: fieldConfig?.fieldB.min ?? 0, max: fieldConfig?.fieldB.max, size: "xs", variant: "outline", sx: { width: '100%' }, isOnChangeOnlyOnBlur: true, disabled: props.schema.readOnly, value: item.valueB ?? undefined, isInvalid: !hasValue(item.valueB), rightElement: fieldConfig?.fieldB.unit, onChange: (value) => handleChangeValueB(index, value) }), _jsx(IconButton, { size: "smSquare", "aria-label": "", variant: "ghost", isDisabled: props.schema.readOnly || isDeleteRawDisabled, icon: _jsx(Svg, { size: "s12", name: "Cross" }), onClick: () => handleDelete(index) })] }, `${item.valueA}_${item.valueB}_${index}`))), fieldValues?.value.length === 0 && (_jsx(Center, { h: "60px", fontSize: "12px", color: "bodyText", children: "\u041D\u0435\u0442 \u0442\u043E\u0447\u0435\u043A" }))] })] }), !props.schema.readOnly && (!isChecked || !fieldConfig?.isCheckbox) && (_jsx(Button, { variant: "ghost", size: "smSquare", width: "100%", onClick: handleAdd, children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u043E\u0447\u043A\u0443" }))] }) }) }));
};
export const OilSampleCurvesJsField = memo(OilSampleCurvesJsFieldFC);
//# sourceMappingURL=OilSampleCurvesJsField.js.map